const zh = {
    lang_person_center: "個人中心",
    lang_log_out: "登出",
    lang_controlCenter: "控制中心",
    lang_communal_card: "公共名片",
    lang_my_memberwork: "我的名片",
    lang_account_info: "我的信息",
    lang_my_hobbies: "我的興趣",
    lang_my_agent: "我的代理",
    lang_return: "返回",
    lang_request_error: "網絡異常",
    lang_user_error: "賬戶異常",
    lang_login_in: "登錄賬戶",
    lang_all: "全部",
    lang_applying: "申請中",
    lang_stop_agent: "停止代理",
    lang_passed: "已通過",
    lang_month_bill: "月結單",
    lang_introduction: "一個跨地域的商品展覽中心",
    lang_news: "資訊",
    lang_becomestore: "建立商店",
    lan_line_me:"聯繫我們",
    lan_common_problem:"常見問題",
    lan_feedback:"意見反饋",
    lan_privacy_agreement:"隱私協議",
    lan_shopping_terms_of_service:"購物服務條款",
    lan_agency_terms:"代理商條款",
    lang_about: "關於",
    lang_working_hours: "工作時間",
    lang_hotline: "熱線",
    lang_take_down: "已下架",
    lang_cancel_agent: "取消代理",
    lang_cancel_agent_success: "取消代理成功",
    lang_memberwork_collection: "名片收錄",
    lang_collection_memberwork: "收錄名片",
    lang_memberwork_agent: "申請名片",
    lang_memberwork_collection_btn: "名片收錄請求",
    lang_add_memberwork: "添加名片",
    lang_edit_memberwork: "修改名片",
    lang_delete_memberwork: "刪除名片",
    lang_open_chat: "開啟聊天室",
    lang_link: "鏈接",
    lang_sending_method: "發送方式",
    lang_memberwork_info: "名片信息",
    lang_operate: "操作",
    lang_enter_complete: "請輸入完整",
    lang_modify_success: "修改成功",
    lang_delete_success: "刪除成功",
    lang_delete_confirm: "確定刪除嗎？",
    lang_not_disclose_card: "是否確定不公開此名片到公眾？",
    lang_open_disclose_card: "是否確定公開此名片到公眾？",
    lang_not_disclose_phone_card: "是否確定不公開此名片的私人電話號碼？",
    lang_open_disclose_phone_card: "是否確定公開此名片的私人電話號碼？",
    lang_memberwork_delete_last_error: "不能刪除最後一張名片!",
    lang_memberwork_delete_new_error: "不能刪除最新的名片！",
    lang_open_personal_chat: "聊天",
    lang_forward: "轉發",
    lang_delete: "刪除",
    lang_revoke: "撤銷",
    lang_product_basic_information: "產品基礎信息",
    lang_product_category: "產品類別",
    lang_product_description: "產品介紹",
    lang_personal_retail: "個人零售",
    lang_commercial_trade: "商業貿易",
    lang_serve: "服務",
    lang_preview: "預覽",
    lang_save: "保存",
    lang_confirm_release: "確定發佈嗎？",
    lang_release_success: "發佈成功",
    lang_confirm_save: "確定保存嗎？",
    lang_save_success: "保存成功",
    lang_save_failed: "保存失敗",
    lang_date: "日期",
    lang_date_select: "日期選擇",
    lang_print: "列印",
    lang_month_total_bill: "當月總參考佣金",
    lang_merchant: "商家",
    lang_merchant_info: "商家信息",
    lang_commission: "佣金",
    lang_password_inconsistent: "兩次輸入的密碼不一致",
    lang_read_agree: "我已閱讀並同意",
    lang_Terms_Policy: "條款&政策",
    lang_register: "註冊",
    lang_forget_password: "找回密碼",
    lang_back: "上一步",
    lang_next: "下一步",
    lang_Submit_Pay:"提交&支付",
    lang_repeated_email: "該郵箱已被註冊",
    lang_error_format_email: "郵箱格式錯誤",
    lang_account_password_error: "賬戶或密碼錯誤",
    lang_email_not_exist: "該郵箱未被注冊！",
    lang_index: "首頁",
    lang_agent_delete_warning: "刪除代理將會刪除所有代理產品和相關的購買記錄，確定刪除嗎？",
    lang_cancel_agent_warning: "取消代理將會下架所有代理商品，確定嗎？",
    lang_release: "發佈",
    lang_start_chat: "發起聊天",
    lang_modify_information: "修改信息",
    lang_email: "電子郵箱",
    lang_login_email: "電子郵箱(登錄賬戶)",
    lang_name: "姓名",
    lang_address: "地址",
    lang_mobile: "行動裝置",
    lang_mobile_number: "手機號碼",
    lang_password: "密碼",
    lang_provide_service_type: "提供服務類型",
    lang_none: "無",
    lang_education_time: "教育時間",
    lang_education_location: "教育地點",
    lang_academic_and_content: "學歷-學歷內容",
    lang_location_academic_and_content: "教育地點-學歷-學歷內容",
    lang_certificate: "證書",
    lang_add: "添加",
    lang_basic_information: "基本信息",
    lang_educational_information: "教育信息",
    lang_memberwork_holder: "名片夾",
    lang_welcome_you: "歡迎您",
    lang_shopopee_person: " 個人零售",
    lang_shopopee_service: " 服務平台",
    lang_shopopee_trade: " 商業貿易",
    lang_new_platform: "全新推廣產品平台",
    lang_unlimited_release: "不同產品 無限發佈",
    lang_build_your_store: "建立你的店鋪",
    lang_your_store: "我的店鋪",
    lang_from_different_web: "來自不同商戶網絡服務器",
    lang_contact: "聯繫",
    lang_support_different: "支持不同流動裝置",
    lang_quickly_search: "快速尋找你想產品!",
    lang_connect_different: "凝聚不同商戶",
    lang_improve_business: "強化商戶管理",
    lang_sign_up: "馬上成為會員",
    lang_24_hours: "全天候運作",
    lang_24_hours_operation: "24 小時不間斷",
    lang_various_payment_method: "不同付款方式",
    lang_credit_card: "信用卡",
    lang_multiple_member_discount: "Discount不同會員不同優惠",
    lang_member_discount_by_level_setting: "設立不同會員折扣",
    lang_erp_sup: "完整 ERP 支持每間商店",
    lang_perfect_integration: "系統綜合運作 完美結合網站及POS系統",
    lang_distributed_data_design: "分散式數據設計",
    lang_newest: "最新消息",
    lang_bargain_recommendation: "至筍推薦",
    lang_latest_product: "最新產品",
    lang_recommend_for_you: "為你推薦",
    lang_feedback: "意見反饋",
    lang_feedback_info_error: "請填寫我們聯繫你的郵箱、稱呼、意見信息，方便我們反饋和聯繫你",
    lang_recommended_bamboo_shoots: "店家推薦",
    lang_latest_product_recommendation: "最新產品推薦",
    lang_no_goods: "沒有商品",
    lang_success_agent: "已申請，等待商家通過",
    lang_repeat_agent: "已申請代理此產品，請勿重複申請",
    lang_request_agent: "申請收錄",
    lang_success_include: "收錄成功",
    lang_success_Wait_pass_include: "已申請，等待對方通過",
    lang_success_include_to_cards: "收錄成功，是否去到名片",
    lang_repeat_include: "已申請收錄該名片，請勿重複申請",
    lang_view_business_cards: "查看商家名片",
    lang_prompt: "提示",
    lang_will_take: "即將帶你到",
    lang_website: "網站",
    lang_my_promotion: "我的推廣",
    lang_reset_alert: "請去郵箱查看，請留意電郵可能會被發到垃圾郵箱！",
    lang_sure: "確定",
    lang_live_promotion: "直播推廣",
    lang_product_promotion: "產品推廣",
    lang_add_promotion: "新增推廣",
    lang_under_review: "審核中",
    lang_approved: "通過審核",
    lang_approval_failed: "未通過",
    lang_approval_cancel: "取消審核",
    lang_state: "狀態",
    lang_company: "公司",
    lang_link_company: "聯繫公司",
    lang_company_name: "公司名稱",
    lang_title: "標題",
    lang_promotion_date: "推廣日期",
    lang_live_time: "直播時間",
    lang_live_link: "直播鏈接",
    lang_content: "內容",
    lang_modify: "修改",
    lang_update_img_note: "上傳展示圖片, 圖片名稱請勿包含中文",
    lang_update_qrcode: "上傳二維碼",
    lang_choose_img: "選擇圖片",
    lang_mr: "先生",
    lang_miss: "小姐",
    lang_mrs: "太太",
    lang_appellation: "稱謂",
    lang_memberwork: "名片",
    lang_memberwork_whatsApp: "whatsApp名片",
    lang_online_memberwork: "聊天名片",
    lang_pass_add: "通過並添加",
    lang_edit_information: "編輯信息",
    lang_hint_not_whatsapp: "用戶未設置電話號碼",
    lang_copy: "複製",
    lang_paste: "粘貼",
    lang_clear: "清空",
    lang_backgroud_color: "背景顏色",
    lang_choose_background_img: "選擇名片底圖",
    lang_choose_template: "選擇模板",
    lang_select_special_effects: "選擇底圖特效",
    lang_choose_share_background_img: "選擇背景",
    lang_working_hours_alert: "后一個不填写为至今",
    lang_company_logo: "公司logo",
    lang_company_name_eng: "公司名稱(英文)",
    lang_company_address: "公司地址",
    lang_company_address_eng: "公司地址(英文)",
    lang_company_telphone: "公司電話",
    lang_company_telphone_2: "公司電話2",
    lang_company_email: "公司電郵",
    lang_my_email: "我的電郵",
    lang_your_name: "你的姓名",
    lang_your_name_eng: "你的姓名(英文)",
    lang_company_fax: "公司傳真",
    lang_position_company: "公司職位",
    lang_telephone: "手機號碼",
    lang_your_profile: "你的簡介",
    lang_company_introduction_link: "公司介绍链接",
    lang_product_introduction_link: "产品介绍链接",
    lang_self_introduction_link: "自我介绍链接",
    lang_jumpto: "跳轉",
    lang_close: "關閉",
    lang_goto: "前往",
    lang_text: "文字",
    lang_position: "職位",
    lang_name_eng: "姓名(英文)",
    lang_self_introduction: "自我介紹",
    lang_drag: "拖動",
    lang_setting: "設置",
    lang_clear_confirm: "確定清空嗎？",
    lang_selling_price: "銷售價",
    lang_product_information: "產品信息",
    lang_product_name_hk: "產品名稱（中文）",
    lang_product_name_en: "產品名稱（副語言）",
    lang_product_description_hk: "產品描述（中文）",
    lang_product_description_en: "產品描述（副語言）",
    lang_fillComplete:"請填寫完整",
    lang_product_cost: "產品銷售價格:HKD",
    lang_product_purchaseCost: "產品購買價格：HKD",
    lang_product_gross_weight: "產品重量:kg",
    lang_product_unit: "單位",
    lang_add_product: "添加產品",
    lang_sales_volume: "銷售量",
    lang_commission_payable: "參考佣金",
    lang_unpaid: "未支付",
    lang_personal: "個人",
    lang_link_personal: "聯繫個人",
    lang_personal_chat: "個人聊天",
    lang_product_chat: "產品聊天",
    lang_service_chat: "服務聊天",
    lang_information_chat: "信息聊天",
    lang_open: "開啟",
    lang_open_success: "開啟聊天室成功",
    lang_please_select_user: "請選擇用戶",
    lang_chat_room_name: "聊天室名称",
    lang_please_input_room: "請輸入聊天室名稱",
    lang_service_request: "服務申請",
    lang_service_type_selection: "服務類型選擇",
    lang_information_content: "資訊內容",
    lang_choose_service_provider: "選擇服務商家",
    lang_all_businesses: "所有商家",
    lang_select_top: "選擇前",
    lang_published_success:"發佈成功",
    lang_published_failed:"發佈失敗",
    lang_send: "發送",
    lang_please_service_category: "請選擇服務類別",
    lang_not_found_provider: "沒有找到對應類別的商家",
    lang_select_provider: "選擇服務商家",
    lang_input_information: "請輸入資訊內容",
    lang_please_login_in: "請登錄賬戶",
    lang_input_error: "請輸入關鍵字",
    lang_search_result: "搜索結果",
    lang_my_interests: "我的興趣",
    lang_select_person_type: "請選擇你感興趣的個人零售產品類型",
    lang_select_trade_type: "請選擇你感興趣的商業貿易產品類型",
    lang_commodity_platform: "商品平台",
    lang_service_platform: "服務平台",
    lang_agent: "代理",
    lang_sale: "銷售",
    lang_buyer_login: "購買者郵箱",
    lang_buyer_name: "購買者姓名",
    lang_send_success: "發送成功,請去郵箱查看",
    lang_not_active_alert: "您的賬戶暫時未認證，是否重新發送認證到郵箱？",
    lang_resend_code_hint_not: "未收到郵件？",
    lang_resend_code: "重新發送",
    lang_product_name: "商品名稱",
    lang_related_products: "相關產品",
    lang_products: "產品",
    lang_sales_area: "銷售區產品",
    lang_agency_area: "代理區產品",
    lang_font_select: "字體",
    lang_font_size: "字體大小",
    lang_font_color: "字體顏色",
    lang_font_bold: "字體加粗",
    lang_width: "长",
    lang_height: "宽",
    lang_please_choose_enter: "請選擇進入",
    lang_expression: "表情",
    lang_share_content: "分享內容",
    lang_input_share_email_address: "請輸入接收分享的郵箱地址",
    lang_share_success: "分享成功",
    lang_upload: "上傳",
    lang_upload_success: "上傳成功",
    lang_agent_request: "申請代理",
    lang_go_shop_href: "請注意，您即將離開 Shopopee ,進入到",
    lang_login: "登錄",
    lang_forget_password_text: "忘記密碼",
    lang_approval_failed_text: "審核未通過",
    lang_please_select_type: "請選擇類別",
    lang_not_bind_3d_shop: "未綁定3D店鋪",
    lang_release_approval: "發佈成功，已提交商家審核",
    lang_save_approval: "保存成功，已提交商家審核",
    lang_feedback_submitted_successfully:"提交成功，感謝您的建議，我們將在郵箱盡快回復您。",
    lang_details: "詳情",
    lang_select_agent: "選擇代理商",
    lang_loaded_end: "已加載到底",
    lang_load_more: "加載更多",
    lang_curr_memberwork: "當前名片",
    lang_add_new_memberwork_confirm: "添加新名片會導致當前名片失效，確定添加嗎？",
    lang_copy_success: "已將內容複製到剪切板",
    lang_order_unpaid: "訂單未支付",
    lang_user_not_found: "用戶不存在",
    lang_my_order: "我的訂單",
    lang_my_hall_order: "我的展會單",
    lang_completed: "已完成",
    lang_edu_input_alert: "請完整填寫教育信息!",
    lang_commission_total: "參考佣金合計",
    lang_null: "空",
    lang_personal_link: "個人鏈接",
    lang_upload_custom: "上傳自定義",
    lang_null_alert: "空，需填寫內容",
    lang_setting_default_memberwork: "設置默認名片",
    lang_setting_default_memberwork_alert: "您是否需要修改默認名片？",
    lang_cancel: "取消",
    lang_invalid_item_alert: "此購買鏈接已失效，請點擊首頁查看其他",
    lang_order_no: "訂單號",
    lang_contact_way: "聯繫方式",
    lang_date_order: "下單日期",
    lang_is_agree: "請查看並勾選同意協議",
    lang_go_eshopopee_confirm: "溫馨提醒：線上店鋪服務由E-Shopopee提供，您即將離開shopopee，前往E-Shopopee網站。",
    lang_memberwork_record: "推薦記錄",
    lang_hyperlink: "超鏈接",
    lang_memberwork_record_for_edit: "推薦記錄",
    lang_memberwork_record_log: "推薦記錄",
    lang_edit_share_line: "填寫分享平台個人鏈接",
    lang_edit_share_QRCode: "請上傳平台個人二維碼",
    lang_wrok_show_commpany_tpye: "名片展示公司通訊",
    lang_wrok_show_personal_tpye: "名片展示個人通訊",
    lang_time: "時間",
    lang_img: "圖片",
    lang_QRCode: "二維碼",
    lang_personal_introduction: "個人介紹",
    lang_company_profile: "公司介紹",
    lang_shopopee_card: "名片card",
    lang_select_local_img: "選擇本地圖片",
    lang_new_join: "最新加入",
    lang_please_select_product: "請選擇商品",
    lang_novice_guide: "新手指引",
    lang_video_introduction: "視頻介紹",
    lang_input_password: "請輸入密碼",
    lang_reset_password_success: "修改成功，請重新登錄！",
    lang_modification_password: "修改密碼",
    lang_new_password: "新密碼",
    lang_confirm_password: "確認密碼",
    lang_new_user_guide: "新用戶操作指南",
    lang_card_layout_setting_hint: "企業名片佈局介紹",
    lang_card_layout_setting: "企業名片設置",
    lang_merchant_operation_guide: "商戶操作指南",
    lang_your_email: "您的電郵",
    lang_account_email: "賬戶郵箱",
    lang_free_registration: "免費註冊",
    lang_free_registration_now: "立即免費註冊",
    lang_custom_edit: "自定義編輯",
    lang_upload_bg_img: "上傳背景圖",
    lang_head_portrait: "用戶頭像",
    lang_skip_save: "跳過並保存",
    lang_skip: "跳過",
    lang_copied_clipboard: "已複製到剪切板",
    lang_related_goods: "相關商品",
    lang_message: "訊息",
    lang_sys_message: "系統消息",
    lang_memberwork_list: "名片列表",
    lang_my: "我的",
    lang_language_setting: "語言設置",
    lang_company_register: "企業註冊",
    lang_company_website: "公司網站",
    lang_company_info: "公司信息",
    lang_submit: "提交",
    lang_required: "必填",
    lang_chat_server_error: "網絡異常，無法連接聊天伺服器",
    lang_authenticate_expiration: "認證到期",
    lang_company_not_exist: "公司不存在",
    lang_not_exist: "不存在",
    lang_certified: "已認證",
    lang_cancel_certifie: "取消認證",
    lang_certifie: "認證",
    lang_not_certified: "未認證",
    lang_under_certification: "認證中",
    lang_expired: "已過期",
    lang_not_active: "未激活",
    lang_not_fill: "未填寫",
    lang_add_user: "添加用戶",
    lang_edit_company_card_template: "編輯企業名片模板",
    lang_company_template_save_confirm: "修改企業名片模板會修改企業所有人員的名片，此操作可能需要較長時間，確定修改嗎？",
    lang_company_info_save_confirm: "修改公司信息會修改企業所有人員的名片，此操作可能需要較長時間，確定修改嗎？",
    lang_user: "用戶",
    lang_log_off: "註銷",
    lang_department_limit_warning: "部門數量已達上限，如需繼續添加請購買員工用戶數量",
    lang_delete_department_warning: "無法刪除，部門中存在員工",
    lang_input_department_name: "填寫部門名稱",
    lang_input_position_name: "填寫職位名稱",
    lang_department_name: "部門名稱",
    lang_position_name: "職位名稱",
    lang_member_info: "用戶信息",
    lang_admin_user: "管理員",
    lang_edit_staff_confirm: "修改用戶信息會修改名片信息，此操作可能需要較長時間，確定修改嗎？",
    lang_frist_default_memberwork_alert: "歡迎使用Shopopee，已為您生成了企業名片，您之後可以在公司信息中修改公司名片模板",
    lang_staff_frist_default_memberwork_alert: "歡迎使用Shopopee，已使用您公司的名片模板生成了企業名片",
    lang_cancel_last_admin_alert: "不能刪除最後一名管理員",
    lang_unable_to_chat_with_oneself: "不能和自己聊天",
    lang_your_memberwork: "您的名片",
    lang_apply_certification: "申請認證",
    lang_company_auth: "企業認證",
    lang_apply_list: "認證記錄",
    lang_apply_information: "記錄信息",
    lang_modify_company_info: "修改公司信息",
    lang_personal_info: "個人信息",
    lang_company_memberwork: "企業名片",
    lang_logooff_confirm_1: "您現在正在進行註銷賬戶操作，確定嗎？",
    lang_logooff_confirm_2: "註銷賬戶將永久刪除該賬戶，該操作無法恢復，確定嗎？",
    lang_logoff_success: "註銷成功",
    lang_company_code: "公司編號",
    lang_optional_information: "選填信息",
    lang_default_password_label: "若不填寫密碼，則默認密碼為",
    lang_become_company: "成為企業用戶",
    lang_become_company_confirm_1: "成為企業用戶後您將可以使用企業管理功能，但您的名片樣式將需要重新設置，該操作不可逆，確定嗎？",
    lang_become_company_confirm_2: "您即將成為企業用戶，操作成功後您需要重新登錄，確定嗎？",
    lang_edit_item: "編輯商品",
    lang_more_info: "更多信息",
    lang_retract: "收起",
    lang_company_message: "企業訊息",
    lang_employee_message: "員工訊息",
    lang_clear_success: "清除成功",
    lang_hint_download: "請下載shopopeeAPP使用該功能",
    lang_clear_fail: "清除失敗",
    lang_view_staff_message: "查看員工訊息",
    lang_log_off_login: "您的公司已註銷，是否重新激活？",
    lang_log_off_self_alert_1: "確定要註銷賬戶嗎？",
    lang_log_off_self_alert_2: "您現在正在註銷賬戶，確定嗎？",
    lang_all_empty: "沒有記錄",
    lang_message_settings: "消息設置",
    lang_cache_clear: "緩存清除",
    lang_about_us: "關於我們",
    lang_version_info: "版本信息",
    lang_log_out_2: "退出登錄",
    lang_notification_bar: "通知欄",
    lang_vibration: "震動",
    lang_bell: "鈴聲",
    lang_select_card_animation: "選擇出場動畫",
    lang_download: "下載",
    lang_auth_your_email: "認證您的郵箱",
    lang_select: "選擇",
    lang_select_card: "選擇名片",
    lang_staff_limit_warning: "員工數量已達上限，如需繼續添加請購買員工數量",
    lang_logoff_company: "企業註銷",
    lang_logoff_company_confirm: "註銷公司將清除包括公司所有員工的數據，您確定要註銷公司嗎？",
    lang_logoff_company_confirm_2: "您確定要註銷公司嗎？您可以在二十四小時內重新激活公司",
    lang_company_logoff_login_alert: "您公司的管理員正在註銷公司，無法登錄",
    lang_include_card: "收錄的名片",
    lang_chat_message: "交談訊息",
    lang_CAPTCHA: "驗證碼",
    lang_please_email: "請輸入郵箱",
    lang_send_vcode_alert: "請去郵箱查看驗證碼",
    lang_vcode_error: "驗證碼錯誤",
    lang_bill: "我的賬單",
    lang_use_app_browser: "請使用手機瀏覽器打開下載~",
    lang_download_hint_android: "最低要求需要 Android 作業系統 7.1 或更新版本",
    lang_download_hint_ios: "最低要求需要 iOS 作業系統  15.0 或更新版本",
    lang_select_target_member: "選擇目標用戶",
    lang_select_target_member_hint: "所收錄的所有名片及聊天記錄將轉移至以下目標用戶，請選擇",
    lang_select_one_target_member_hint: "的名片及聊天記錄將轉移至以下目標用戶，請選擇",
    lang_mobile_company_number: "手機號碼",
    lang_buy: "購買",
    lang_submit_apply: "提交申請",
    lang_element: "元件",
    lang_bill_id: "賬單單號",
    lang_bill_order_type: "賬單類型",
    lang_bill_email: "下單者郵箱",
    lang_bill_username: "下單者姓名",
    lang_bill_tel: "下單者電話",
    lang_bill_total: "總金額",
    lang_pay_no: "支付單號",
    lang_pay_state: "支付狀態",
    lang_pay_date: "支付時間",
    lang_pay_method: "支付方式",
    lang_bill_state: "訂單狀態",
    lang_order_date: "下單日期",
    lang_verify_date: "審核通過時間",
    lang_resubmit: "重新提交",
    lang_paid: "已支付",
    lang_refused: "已拒絕",
    lang_company_auth_apply: "企業認證申請",
    lang_business_paper: "商業登記證",
    lang_span_selected_play_hint: "已選HKD$",
    lang_click: "點擊",
    lang_communication_method:"通訊方式",
    lang_show:"顯示",
    lang_hide:"隱藏",
    lang_show_hide:"顯示/隱藏",
    lang_hint_is_animate_null:"請填寫自定義動畫",
    lang_not_share_not_open:"會員設置不公開，禁止分享",
    lang_show_share_greetings:"分享問候語",
    lang_set_watsapp:"設置whatsApp",
    lang_upload_paper_notice_1: "上傳營業商業登記證附件",
    lang_format: "格式",
    lang_upload_paper_notice_2: "上傳完成後去PayPal支付認證費用",
    lang_upload_paper_notice_3: "點擊提交&支付",
    lang_upload_paper_notice_4: "請將圖片文件拖拽至此區域",
    lang_upload_paper_notice_5: "點擊選擇圖片",
    lang_note: "注意",
    lang_upload_paper_notice_6: "如已上傳業商業登記證附件，請點擊提交認證，支付",
    lang_upload_paper: "上傳許可證",
    lang_add_staff_limit: "增加員工數量上限",
    lang_transfer: "轉移",
    lang_transfer_all: "全部轉移",
    lang_select_card_type: "選擇名片類別",
    lang_please_input_vcode: "請輸入驗證碼",
    lang_input_vcode_note: "您的啟動密碼已發送至您的郵箱",
    lang_select_card_type_note: "請選擇您所涵蓋的類別領域，選擇後您的名片即可展示在對應類別下方",
    lang_why_auth_title: "為何要進行企業認證？",
    lang_why_auth_alert: "認證您的企業可以確保貴司在shopopee平臺上的真實性及唯一性",
    lang_why_auth_alert2: "認證您的企業可以提高貴司在shopopee平臺上的信用度",
    lang_why_auth_alert3: "認證您的企業可以保留貴司的聊天記錄信息1年",
    lang_return_from_eshopopee: "您需要返回e-shopopee嗎？",
    lang_invite: "邀請",
    lang_default_password_alert: "請設置登錄密碼",
    lang_connect_chat_server_failed: "連接聊天服務器失敗",
    lang_recommend_person_sales: "銷售推薦",
    lang_recommend_trade_sales: "貿易推薦",
    lang_recommend_service_sales: "服務推薦",
    lang_open_e_shopop_hint: "免費申請e-shopopee: 即時開通3D店鋪，3D網站及企業管理系統，獲贈30天使用期限，是否開通?",
    lang_no_cards: "沒有名片",
    lang_anonymous_user: "匿名會員",
    lang_user_exception: "會員賬戶異常",
    lang_chat_update_file_failed: "文件上傳失敗",
    lang_temporary: "臨時",
    lang_please_input_videos_input: "請輸入視頻鏈接",
    lang_error_time_num: "請輸入正確的時間",
    lang_robot_setting: "機器人設置",
    lang_welcome_message: "歡迎語",
    lang_auto_reply_switch_text: "是否開啟自動回復",
    lang_animation_type: "動畫類型",
    lang_video_link_input: "視頻鏈接",
    lang_flat_scrolling: "平面滾動",
    lang_descriptive_text: "描述文字",
    lang_animation_playback_time: "動畫播放時間",
    lang_video_cover: "視頻封面",
    lang_update_img_card_addinfo6_hint:"請上傳400*250大小的圖片,youtu視頻不上傳默認為youtu視頻封面",
    lang_3d_scrolling: "3D滾動",
    lang_connect_chat_sever_error_405: "無法連接聊天服務器，錯誤代碼405",
    lang_anonymous: "匿名",
    lang_business_currently_no_product_message: "抱歉，商家暫無相關產品",
    lang_empty_roomname_error: "群組名稱不能為空",
    lang_confirm_remove_chat_user: "確定要移除該名成員嗎？",
    lang_dissolve_group: "解散群組",
    lang_dissolve_group_confirm1: "確定要解散群組嗎？",
    lang_dissolve_group_confirm2: "您現在正在解散該群組，該操作不可恢復，確定嗎?",
    lang_dissolve_success: "解散群組成功",
    lang_return_chat: "返回聊天",
    lang_chat_room: "聊天群組",
    lang_create_multiple_group: "創建多人群聊",
    lang_select_user: "選擇用戶",
    lang_invite_success: "邀請成功",
    lang_input_groupname_please: "请输入群组名称",
    lang_click_to_view: "點擊查看",
    lang_auto_welcome_message: "歡迎您，智能助手Chris為您服務!",
    lang_group_name: "群組名稱",
    lang_group_avatar: "群頭像",
    lang_group_members: "群成員",
    lang_share_chat_group: "分享群聊",
    lang_join_chat_group: "加入群聊",
    lang_join_chat_success: "加入群聊成功",
    lang_join_chat_alert: "您已加入此群組，請勿重複加入",
    lang_expiration: "有效期",
    lang_titles: "銜頭",
    lang_date_error_1: "日期不正確",
    lang_submit_chat_join_success: "已提交管理員審核",
    lang_apply_join: "申請加入",
    lang_join_success: "加入成功",
    lang_sure_pass_apply: "確定批准申請嗎？",
    lang_creator: "創建者",
    lang_default_user_info_alert: "請設置資料",
    lang_toggle_to_person_user: "切換為個人用戶",
    lang_toggle_to_company_user: "切換為公司用戶",
    lang_toggle_user_confirm: "切換後您的名片將不顯示公司有關的所有信息，但您可以在之後重新切換為公司用戶，確定要切換為個人用戶嗎？",
    lang_toggle_company_confirm: "切換後您也許需要重新填寫公司信息，但您之後仍然可以切換為個人用戶，確定要切換為公司用戶嗎？",
    lang_toggle_success_pls: "切換成功，請重新登錄",
    lang_my_product: "我的產品",
    lang_manage_product: "管理產品",
    lang_product_list: "產品列表",
    lang_confirm_go_backstage: "即將跳轉到商家後台，確定嗎？",
    lang_title_backstage: "供應商後台",
    lang_file_document_center: "檔案中心",
    lang_file_oversize: "文件大小不能超過50MB",
    lang_file_type_error_1: "不能上傳此格式的文件",
    lang_select_worktype_pls: "請選擇名片類別",
    lang_file_not_found_1: "文件已被刪除",
    lang_now_downloading: "已開始下載",
    lang_product_link:  "產品鏈接",
    lang_product_img: "產品圖片",
    lang_card_product_1: "名片產品",
    lang_select_card_product_1: "選擇名片產品",
    lang_Easy_registration: "簡易註冊",
    lang_Advanced_registration: "進階註冊",
    lang_person_registration: "個人註冊",
    lang_select_card_template_please: "請選擇您要使用的名片模板",
    lang_select_memberwork_template_confirm: "確定要使用該模板嗎？",
    lang_upload_product_confirm_1: "您需要上傳產品嗎？",
    lang_sure_restart_guide_confirm: "確定要進行快速導引嗎？",
    lang_product_sale_website: "產品促銷網",
    lang_pay_setting: "付款設置",
    lang_add_paymethod_text: "添加支付方式",
    lang_paymethod_list: "支付方式列表",
    lang_main_name_text: "主語言名稱",
    lang_paralanguage_name: "副語言名稱",
    lang_notes: "備註",
    lang_paymentmethod: "付款方式",
    lang_revice_account: "收款賬號",
    lang_commission_text: "手續費",
    lang_percent_text: "百分比",
    lang_in_the_store: "進店查看",
    lang_commission_per: "手續費(百分比)",
    lang_dispatch: "派單",
    lang_sure_dispatch: "確定要派單嗎？",
    lang_login_success: "登錄成功",
    lang_set_admin: "設為管理員",
    lang_unset_admin: "解除管理員",
    lang_set_admin_confirm: "確定要設為管理員嗎？",
    lang_unset_admin_confirm: "確定要解除管理員嗎？",
    lang_operate_success: "操作成功",
    lang_dispatch_success: "派單成功",
    lang_complete_receipt_confirm: "確定要完成此回執單嗎？",
    lang_already_select_receipt: "已選擇回復此回執單消息",
    lang_already_cancel_receipt: "已取消回復回執單消息",
    lang_input_order_no_please: "請輸入單號",
    lang_order_no_repeat: "單號重複",
    lang_receipt_no_span: "回執單號",
    lang_send_group_notice_msg: "發送群公告",
    lang_input_group_notice_pls: "請輸入群公告內容",
    lang_send_success_text_1: "發送成功",
    lang_prohibition: "禁言",
    lang_prohibiting: "禁言中",
    lang_input_pls_text: "請輸入",
    lang_remove_member_text: "移除成員",
    lang_cancel_select_receipt: "取消選擇回執單",
    lang_in_progress: "進行中",
    lang_exhibition_not_currently:"招商中",
    lang_worktype_num_limit: "最多選擇3個類別",
    lang_change_style_text: "更換樣式",
    lang_share_card: "分享名片",
    lang_Promotion_text_1: "宣傳推廣",
    lang_select_company_type: "選擇企業類別",
    lang_company_card_animation: "企業名片動畫",
    lang_collection_btn: "收錄請求",
    lang_invite_user_text: "邀請用戶",
    lang_add_limit_num: "增加上限",
    lang_cancel_admin: "取消管理員",
    lang_set_admin_text: "設置管理員",
    lang_shopopee_person_text: "個人零售",
    lang_shopopee_service_text: "服務",
    lang_shopopee_trade_text: "商業貿易",
    lang_Address_book: "通訊錄",
    lang_query_card_text: "搜索名片",
    lang_shop_text_1: "店鋪",
    lang_my_3D_shop: "3D店鋪",
    lang_apply_change: "申請交換",
    lang_related_card_not_found: "沒有找到相關名片",
    lang_add_address_book: "添加通訊錄",
    lang_email_or_tel_repeat: "郵箱或電話重複",
    lang_user_repeat: "用戶已存在",
    lang_send_addinfo9_error_1: "請勿重複邀請",
    lang_Quick_guidance: "快速導引",
    lang_search_add_card: "搜索添加名片",
    lang_enter_address_book: "輸入通訊錄",
    lang_invite_to_shopopee: "邀請加入Shopopee",
    lang_scan: "掃一掃",
    lang_import_to_address_book: "導入通訊錄",
    lang_department: "部門",
    lang_create_group: "創建群組",
    lang_group_type: "群組類型",
    lang_files_text: "個檔案",
    lang_send_sms_confirm: "未添加郵箱，是否使用SMS發送？",
    lang_email_none_text: "未添加郵箱",
    lang_read_address_book_error: "讀取通訊錄失敗",
    lang_company_user_limit : "當前可添加用戶上限為",
    lang_person: "人",
    lang_curr_version_not_sup: "當前版本暫不支持",
    lang_card_info: "名片信息",
    lang_add_admin: "添加管理員",
    lang_group_notice: "群公告",
    lang_Remove_group_members: "移除群組成員",
    lang_remove_operation: "移除",
    lang_select_member_pls: "請選擇成員",
    lang_connot_remove_last_admin: "不能移除最後一名管理員",
    lang_remove_member_confirm: "確定要移除成員嗎？",
    lang_select_pls: "請選擇",
    lang_card_animation: "名片動畫",
    lang_order_item: "訂單商品",
    lang_d_address: "運輸地址",
    lang_d_cost: "運費",
    lang_total_text: "總計",
    lang_shopcart: "購物車",
    lang_ask_text: "詢問",
    lang_ask_item_alert_1: "不能詢問自己的產品",
    lang_submit_order_1: "提交訂單",
    lang_subtotal_1: "小計",
    lang_transport: "運輸",
    lang_transport_method: "送貨方式",
    lang_international_address: "國際地址",
    lang_area_text: "地區",
    lang_transport_cost: "運費參考價",
    lang_pay_commission: "支付手續費",
    lang_total_price: "總價",
    lang_pay_text_1: "付款",
    lang_none_order_item_alert: "訂單中沒有商品",
    lang_select_transport_alert: "請選擇送貨方式",
    lang_select_international_alert: "請選擇國際地址",
    lang_select_address_alert: "請輸入地址",
    lang_select_payment_alert: "請選擇支付方式",
    lang_payment_order_confirm: "付款成功，是否查看訂單？",
    lang_cart_none_item_alert: "購物車中沒有產品",
    lang_cart_item_num_limit_alert: "購物車中的產品數量已達上限",
    lang_already_add_cart_alert: "已添加到購物車",
    lang_jump_to_view: "點擊查看",
    lang_pull_confirm_text_1: "確定下架此商品嗎？",
    lang_pull_success: "下架成功",
    lang_lose_item_alert: "已刪除訂單中的失效商品",
    lang_order_confirm_text: "訂單確認",
    lang_item_info_1: "產品資訊",
    lang_price_text: "價格",
    lang_select_category: "選擇類別",
    lang_set_three_shopman: "設置3D商城店員",
    lang_please_open_eshopopee: "請開通E-Shopopee",
    lang_inv_code_placeholder_hint: "(沒有可不填)",
    lang_inv_code_not_exist: "邀請碼不存在",
    lang_shop_exp: "3D店鋪到期時間",
    lang_no_shop_alert: "未開通店鋪",
    lang_inv_code: "邀請碼",
    lang_inv_gift_notice: "提示：每月如至少一個用戶使用您的邀請碼註冊，即可免費續期店鋪基礎版30日",
    lang_shop_item: "商家產品",
    lang_three_shop_renew: "3D店鋪續期",
    lang_transport_manage: "運輸管理",
    lang_main_language_not_empty: "主語言名稱不能為空",
    lang_sub_language_not_empty: "副語言名稱不能為空",
    lang_transport_cost_not_empty: "運費不能為空",
    lang_transport_cost_not_correct: "運費不正確",
    lang_my_invcode: "我的邀請碼",
    lang_three_shop_share_link: "3D店鋪分享鏈接",
    lang_invcode_reg_link: "邀請碼註冊鏈接",
    lang_inv_record: "邀請記錄",
    lang_buy_card: "購買名片",
    lang_pls_upload_header_img: "請上傳頭像",
    lang_paid_card_not_found: "名片不存在，請聯繫網站管理員",
    lang_company_card_not_found: "公司名片不存在，請聯繫您公司的管理員",
    lang_shop_control_room: "店鋪控制室",
    lang_detail_text_1: "明細",
    lang_staff_num: "員工數量",
    lang_three_shop_exp: "3D店鋪有效期",
    lang_card_front: "名片正面",
    lang_card_opposite: "名片反面",
    lang_select_exp_item_pls: "請選擇有效期",
    lang_pay_confirm_text: "確定支付嗎？",
    lang_customer_bill: "公司賬單",
    lang_repeat_bo_confim: "存在未支付的訂單，請支付或刪除該訂單",
    lang_renew_manage: "續費管理",
    lang_company_admin_limit: "企業管理員上限",
    lang_admin_limit_warning: "管理員數量已達上限，如需繼續添加請購買管理員數量",
    lang_pls_open_three_shop: "請先開通3D店鋪",
    lang_area_code: "電話區號",
    lang_pls_input_ac: "請填寫電話區號",
    lang_auto_replay_offline_switch_text: "是否開啟離線提醒",
    lang_online_time: "在線時間",
    lang_remind_notice_1: "商家當前可能不在線，如長時間未回復您，可進行詢問，商家上線後將第一時間回復您。",
    lang_ask_enterprise: "詢問商家",
    lang_contact_email: "聯繫郵箱",
    lang_contact_tel: "聯繫電話",
    lang_contact_tel_des: "聯繫電話(可不填)",
    lang_ask_content: "詢問內容",
    lang_ask_content_too_long: "詢問內容文字過長",
    lang_pls_input_email: "請填寫聯繫郵箱",
    lang_user_not_input: "用戶未填寫",
    lang_close_offline_notice_pls: "請先關閉離線提醒",
    lang_open_auto_notice_pls: "請先開啟自動回復",
    lang_activate_time: "激活時間",
    lang_format_warning_spc: "不能含有特殊字符",
    lang_unvisivle_account: "已註銷的賬戶",
    lang_staff_num_unlimit: "普通員工無上限",
    lang_company_detail_1: "公司簡介",
    lang_3d_price_1: "3D店鋪價格",
    lang_inv_user_login: "邀請者郵箱",
    lang_inv_user_name: "邀請者姓名",
    lang_exit_preview: "退出預覽",
    lang_new_join_card_1: "最新加入的商盟card",
    lang_company_news_info: "公司資訊",
    lang_new_join_cnews_1: "最新加入的公司簡介及資訊",
    lang_me: "我",
    lang_manger_system: "管理系統",
    lang_buy_nfc_card: "購買NFC名片",
    lang_custom_order: "客戶訂單",
    lang_country: "國家或地區",
    lang_select_country_pls: "請選擇國家或地區",
    lang_add_t_method_1: "添加運輸方式",
    lang_select_market_pls: "請選擇市場",
    lang_company_curr: "貨幣單位",
    lang_product_name_en_2: "產品名稱（英文）",
    lang_product_description_en_2: "產品描述（英文）",
    lang_product_cost_2: "產品銷售價格",
    lang_upload_product: "上傳產品",
    lang_select_product_pls: "請選擇產品類別",
    lang_upload_product_img_pls: "請上傳產品圖片",
    lang_upload_img: "上傳圖片",
    lang_del_confirm: "確定刪除該商品嗎？",
    lang_cn_name: "中文名稱",
    lang_en_name: "英文名稱",
    lang_shop_position: "店鋪位置",
    lang_my_inv: "我的邀請",
    select_market_pls: "請選擇市場",
    lang_login_not_empty: "用戶名不能為空",
    lang_password_not_empty: "密碼不能為空",
    lang_report_data_1: "報表數據",
    lang_open_sound: "開啟聲音",
    lang_mute: "靜音",
    lang_clear_cache: "清除緩存",
    lang_search_text: "搜索",
    lang_my_phone: "我的手機",
    lang_Operator_3d: "營運員",
    lang_doornum_option_text: "門牌號(非必填)",
    lang_area_num: "區號",
    lang_select_area_door_num_pls: "請選擇要前往的區號和門牌號",
    lang_passerby_sentence_1_1: "站在停機坪閃爍光圈旁的三個人可以立即將你帶到想去的地方。",
    lang_passerby_sentence_1_2: "如果你想快速前往某個區域的某個店鋪就去找他們吧。",
    lang_passerby_sentence_2_1: "聽說現在開店的話，店鋪可以免費30天，還贈送對應的網站系統。",
    lang_passerby_sentence_2_2: "如果你有意向的話，現在就去開通店鋪吧。",
    lang_passerby_sentence_3_1: "如果你想咨詢店鋪一些問題的話，可以去找店鋪前面的店員。",
    lang_passerby_sentence_3_2: "他們可以回答你的問題，也能與你交換名片。",
    lang_passerby_sentence_4_1: "每個店鋪前面都有一個廣告牌，你可以通過廣告牌查看店鋪的最新產品。",
    lang_passerby_sentence_5_1: "如果你想購買店鋪的商品，你可以與店員交談時直接下單購買。",
    lang_next_district: "下一區",
    lang_check: "查看",
    lang_view_confirm_msg: "當前有最新表報情況，需要需要查看麼",
    lang_application_to: "申請入駐",
    lang_contact_shopopee_pls: "請聯繫Shopopee",
    lang_Conversation: "交談",
    lang_passerby: "路人",
    lang_Under_renovation: "裝修中",
    lang_shop_website_1: "店鋪網站",
    lang_receive_card_pls: "請您收下我的名片",
    lang_go_next_confirm: "要前往下一個區域嗎?",
    lang_go_eshopopee_shop_confrim_1: "進入",
    lang_go_eshopopee_shop_confrim_2: "的店鋪嗎？(將跳轉至 e-shopopee 網站)",
    lang_welcome_3d_msg_1: "歡迎您，請跟我前往",
    lang_welcome_3d_msg_2: "歡迎光臨 3D shopopee 商城。",
    lang_welcome_3d_msg_3: "香港首個3D展覽中心城，用嶄新的方法推廣您的產品或服務給更多人。",
    lang_welcome_3d_msg_4: "免費申請，馬上拿取您首個3D店鋪門牌吧！",
    lang_welcome_3d_msg_5: "需要我帶您前往其他區域嗎？",
    lang_not_chat_self: "不能跟自己聊天",
    lang_not_open_shop_again: "您已開店，請勿重複申請",
    lang_return_shopopee_confirm: "確定要返回Shopopee嗎？",
    lang_go_eshopopee_confirm_1: "將跳轉至 e-shopopee 網站, 確定嗎?",
    lang_viewers: "瀏覽人數",
    lang_chat_text: "聊天",
    lang_my_account: "我的賬戶",
    lang_open_shop_3d: "開通店鋪",
    lang_edit_staff: "編輯員工",
    lang_join_hall_manager: "參展管理",
    lang_temporary_no_data: "暫無記錄",
    lang_hall_num: "展館號",
    lang_hall_visible_time: "展館有效時間",
    lang_hall_appy_time: "展館報名時間",
    lang_hall_des: "展館描述",
    lang_img_position_display: "對應圖片展示",
    lang_shop_name_pad_1: "店鋪招牌",
    lang_adv_img: "廣告圖",
    lang_join_hall_cost: "參展費用",
    lang_join_hall: "參展",
    lang_entry_time: "報名時間",
    lang_open_time: "開放時間",
    lang_applied: "已申請",
    lang_upload_adv_img_notice: "註:如不上傳圖片則不顯示對應位置的廣告牌，圖片限制大小300KB",
    lang_aspect_ratio: "寬高比",
    lang_upload_shopname_pad_img_pls: "請上傳店鋪招牌圖片",
    lang_applied_warning: "已申請，請勿重複申請",
    lang_apply_success: "申請成功",
    lang_edit: "編輯",
    lang_file_over_limit: "文件大小超出限制",
    lang_pay_1: "支付",
    lang_hall_already_finish: "展會已結束",
    lang_join_hall_time_confirm_1: "店鋪有效期不足，是否前往續期？",
    lang_change_lang_confirm: "修改語言需要重新加載才能生效，現在立即重新加載嗎？",
    lang_sound: "聲音",
    lang_toggle_views: "視角切換",
    lang_guide_text: "指引",
    lang_lang: "語言",
    lang_first_person: "第一人稱",
    lang_third_person: "第三人稱",
    lang_sex: "性別",
    lang_male: "男性",
    lang_female: "女性",
    lang_shopman_sex: "店員性別",
    lang_no_setting: "不設置",
    lang_select_goto_hall: "請選擇要前往的展館",
    lang_go_hall_confirm: "要前往展館嗎？",
    lang_return_3dShop_confirm_1: "要返回3D商業城嗎？",
    lang_shop_item_1: "店鋪商品",
    lang_elevator: "電梯",
    lang_select_floor_num_pls: "請選擇樓層",
    lang_floor_num: "樓層",
    lang_item_1: "商品",
    lang_booth: "展臺",
    lang_go_shop_view: "去店查看",
    lang_go_booth: "前往展臺",
    lang_booth_position: "展臺位置",
    lang_business_directory: "企業名錄",
    lang_goto_floor: "前往樓層",
    lang_pls_select_region: "請選擇地區",
    lang_not_open: "未開放",
    lang_img_size_1: "圖片尺寸",
    lang_return_3d_city: "返回3D商業城",
    lang_language_toggle: "語言切換",
    lang_slow: "慢",
    lang_normal: "正常",
    lang_fast: "快",
    lang_fast_2: "非常快",
    lang_move_speed: "移動速度",
    lang_region_toggle: "地區切換",
    lang_change_region_confirm: "切換地區需要重新加載才能生效，現在立即重新加載嗎？",
    lang_download_company_pdf_confirm: "是否下載企業宣傳冊?",
    lang_chat_group_files: "群組檔案",
    lang_enter_text: "進入",
    lang_group_member: "群組成員",
    lang_none_group_file: "暫無檔案",
    lang_go_eshopopee_confirm_2: "即將跳轉至 E-Shopopee，確定嗎？",
    lang_user_email_has_reg: "用戶郵箱已被註冊",
    lang_add_staff_success_alert_text: "添加成功，註冊認證郵件已發送到郵箱！請去郵件查驗，請留意郵件可能會發送到垃圾郵箱！",
    lang_invite_staff_success_alert_text: "邀請成功，邀請郵件已發送到郵箱",
    lang_invite_staff_fail_alert_text_1: "邀請失敗，對方存在員工",
    lang_add_contact_method_1: "添加通訊方式",
    lang_edit_contact_method_1: "修改通訊方式",
    lang_custom_text: "自定義",
    lang_submit_success: "提交成功",
    lang_receive_email_address: "接收分享的郵箱地址",
    lang_share_Preset_content_1: "您好，這是",
    lang_share_Preset_content_2: "在shopopee的電子名片，請多關照。",
    lang_repeat_include_2: "已收錄該名片，請勿重複收錄",
    lang_3d_business_city: "3D商業城",
    lang_create_shop_success_alert: "創建店鋪成功，您需要添加產品嗎?",
    lang_hk_ex_center_1: "香港展覽中心",
    lang_more_img: "更多圖片",
    lang_Honors_and_Certificates: "榮譽與證書",
    lang_img_text_1: "圖",
    lang_edit_detail_text: "編輯簡介",
    lang_edit_detail_text_to_photo: "編輯簡介(圖片轉文字)",
    lang_temporary_no_join_ex_data: "暫無參展記錄",
    lang_exhibited_products: "參展產品",
    lang_free_to_select: "可選",
    lang_already_select: "已選",
    lang_already_sold: "已售",
    lang_already_reserve: "已訂",
    lang_confirm_select: "確認選擇",
    lang_select_hall_position_pls: "請選擇展位",
    lang_confirm_del_record15_text_1: "確定要刪除預定記錄嗎？",
    lang_input_companyname_pls: "請輸入公司名稱",
    lang_input_companyaddress_pls: "請輸入公司地址",
    lang_input_companytel_pls: "請輸入公司電話",
    lang_input_companyemail_pls: "請輸入公司電郵",
    lang_about_jump_to: "即將跳轉至",
    lang_card_forward: "名片轉發",
    lang_card_editor: "名片編輯",
    lang_go_hongkong: "前往香港",
    lang_unit_code: "單位編碼",
    lang_unit_name_zh: "產品單位名稱(中文)",
    lang_unit_name_en: "產品單位名稱(英文)",
    lang_add_product_unit: "添加產品單位",
    lang_pls_input_unit_zh_name: "請輸入產品單位的中文名稱",
    lang_pls_input_unit_en_name: "請輸入產品單位的英文名稱",
    lang_unit_repeat_warning: "產品單位已存在，請勿重複添加",
    lang_add_success: "添加成功",
    lang_operation_method: "操作方式",
    lang_normal_text: "普通",
    lang_free_perspective: "自由視角",
    lang_region_setting: "地區設置",
    lang_add_region_setting: "添加地區設置",
    lang_save_region_setting: "保存地區設置",
    lang_min_buy_qty: "最低購買量",
    lang_wholesale_setting: "批發設置",
    lang_get_quo_price: "拿報價",
    lang_join_hall_material: "參展產品",
    lang_buy_detail: "購買詳情",
    lang_unit_price: "單價",
    lang_buy_num: "購買數量",
    lang_total_price_num: "總價格",
    lang_search_order_ref: "搜索訂單號",
    lang_bill_record_detail: "賬單詳情",
    lang_select_join_hall_material: "選擇參展產品",
    lang_not_quote_self: "不能和自己拿報價",
    lang_all_region: "所有地區",
    lang_district: "區",
    lang_quotation: "報價單",
    lang_tel_text: "電話",
    lang_email_text: "電郵",
    lang_order_number_text: "單號碼",
    lang_order_date_text: "單日期",
    lang_sale_man: "銷售人員",
    lang_payment_terms: "付款條款",
    lang_product_des: "產品描述",
    lang_qty: "數量",
    lang_curr: "貨幣",
    lang_total: "合計",
    lang_confirm_text: "確認",
    lang_Company_seal_signature: "公司蓋章及簽署",
    lang_delivery_remark: "運輸備註",
    lang_add_delivery_deliveryname: "添加運輸備註",
    lang_chinese_remark: "中文描述",
    lang_english_remark: "英文描述",
    lang_no_support_your_region: "該商品暫不支持您所在區域",
    lang_wholesale: "批發價",
    lang_min_buy_num: "最低購買量",
    lang_get_quote: "獲取報價",
    lang_check_quotion: "確認報價單",
    lang_select_transport_pls: "請選擇運輸方式",
    lang_submit_quotation_confirm_1: "提交成功，要查看报价单吗？",
    lang_chinese_text: "中文",
    lang_my_quotation: "我的報價單",
    lang_select_region_confirm: "確定前往",
    lang_zoom: "縮放",
    lang_myagent: "我的代理",
    lang_agent_1: "代理商",
    lang_supplier: "供應商",
    lang_myagent_1: "我的代理商",
    lang_agent_companycode: "代理商公司代碼",
    lang_agent_companyname: "代理商公司名稱",
    lang_agent_host_address: "代理商域名地址",
    lang_agent_host_company_code: "本公司在代理商域名代碼",
    lang_go_agent_host_warning: "即將跳轉至代理商域名，確定嗎？",
    lang_agent_company: "代理商公司",
    lang_input_agent_host_pls: "請輸入代理商域名地址",
    lang_input_agent_host_company_code_pls: "請輸入本公司在代理商域名代碼",
    lang_supplier_companycode: "供應商公司代碼",
    lang_supplier_name: "供應商名稱",
    lang_supplier_login: "供應商賬號",
    lang_mall_companycode: "商城公司代碼",
    lang_select_supplier_company: "選擇供應商公司",
    lang_sponsor: "主辦方",
    lang_renew: "續費",
    lang_product_manager: "產品管理",
    lang_receive_method_1: "收款方式",
    lang_hall_manager_1: "展會管理",
    lang_return_control_room: "返回控制室",
    lang_add_receive_manager: "添加收款方式",
    lang_Organize_exhibitions: "舉辦展會",
    lang_Join_exhibitions: "參加展會",
    lang_join_exhibitions_manager: "參展管理",
    lang_exhibition_name: "展會名稱",
    lang_exhibition_name_en: "展會英文名稱",
    lang_apply_time: "報名時間",
    lang_exhibition_type: "展會類型",
    lang_exhibition_stage: "展會場景",
    lang_exhibition_des: "展會描述",
    lang_exhibition_des_en: "展會英文描述",
    lang_exhibition_cover: "展會封面",
    lang_exhibition_cover_en: "展會英文封面",
    lang_exhibition_banner_img: "展會條幅",
    lang_exhibition_banner_img_en: "展會英文條幅",
    lang_invite_person_label: "邀請通訊錄成員加入3DShopopee",
    lang_website_manage: "網站管理",
    lang_hall_position_manager: "展位管理",
    lang_hide_item_confirm: "確定隱藏該產品嗎？",
    lang_show_item_confirm: "確定顯示該產品嗎？",
    lang_department_info: "部門信息",
    lang_3d_shop_des: "查看及管理您的店鋪",
    lang_3d_exhibition: "3D展會",
    lang_3d_exhibition_des: "查看及管理您的展會",
    lang_my_website: "我的網站",
    lang_my_website_des: "查看及管理您的網站",
    lang_my_card_des: "查看及管理您的名片",
    lang_manage_sys_des: "查看及管理您的後台中心",
    lang_quotation_des: "查看及管理您的報價單",
    lang_website_setting: "網站設置",
    lang_open_shop_des: "開通3D店鋪",
    lang_open_shop_success: "開通店鋪成功，請重新加載頁面",
    lang_company_manage_sys: "企業管理系統",
    lang_name_eng_1: "英文名稱",
    lang_address_eng_1: "英文地址",
    lang_world_hall: "國際展會",
    lang_local_hall: "本地展會",
    lang_market: "商場",
    lang_hall_1: "展館",
    lang_open_hall_alert: "開展數量已達上限",
    lang_toggle: "切換",
    lang_toggle_hall_confirm_1: "要切換到展館嗎？",
    lang_toggle_shop_confirm_1: "要切換到商場嗎？",
    lang_customer_manage: "客戶管理",
    lang_order_manage: "訂單管理",
    lang_order_i_received: "我收的單",
    lang_order_i_placed: "我下的單",
    lang_order_i_received_des: "查看和管理我收的單",
    lang_order_i_placed_des: "查看和管理我下的單",
    lang_enter_shopmall: "進入商場",
    lang_join_hall_company: "參展公司",
    lang_mall_manage: "商場管理",
    lang_mall_manage_des: "查看和管理我的商場",
    lang_island_manage: "島嶼管理",
    lang_island_manage_des: "查看和管理我的島嶼",
    lang_created_mall: "我的商場",
    lang_join_mall: "入駐商場",
    lang_mall_name: "商場名稱",
    lang_mall_name_en: "商場英文名稱",
    lang_mall_des: "商場描述",
    lang_mall_des_en: "商場英文描述",
    lang_mall_cover: "商場封面",
    lang_mall_cover_en: "商場英文封面",
    lang_mall_banner_img: "商場條幅",
    lang_mall_banner_img_en: "商場英文條幅",
    lang_mall_limit_alert: "展館數量已達上限",
    lang_target_company: "目標公司",
    lang_doornum_text: "門牌號",
    lang_approved_confirm: "確定通過審核嗎？",
    lang_position_occupied: "位置已被佔用",
    lang_shop_settled_in: "入駐商家",
    lang_shop_products: "店鋪產品",
    lang_des: "描述",
    lang_invite_url: "邀請鏈接",
    lang_island_name: "島嶼名稱",
    lang_island_name_en: "島嶼英文名稱",
    lang_island_domain: "島嶼域名",
    lang_island_name_input_alert: "請輸入島嶼名稱",
    lang_shop_manager_1: "商家管理",
    lang_island_merchants: "島嶼商家",
    lang_disable: "禁用",
    lang_enable: "啟用",
    lang_go_other_island: "前往其他島嶼",
    lang_toggle_island: "島嶼切換",
    lang_activate_acc_pls: "請激活賬戶",
    lang_welcome_img: "迎賓圖",
    lang_welcome_img_en: "迎賓圖(英文)",
    lang_description_img: "介紹圖",
    lang_description_img_en: "介紹圖(英文)",
    lang_island: "島嶼",
    lang_auth: "權限",
    lang_not_open_shop: "未開通店鋪",
    lang_companycode: "公司編碼",
    lang_position_move: "移動位置",
    lang_disable_shop: "禁用店鋪",
    lang_edit_auth: "編輯權限",
    lang_staff_manage: "員工管理",
    lang_enable_shop: "啟用店鋪",
    lang_shop_disable: "店鋪被禁用",
    lang_logoff_company_confirm_3: "您正在進行註銷公司操作，該操作無法恢復，確定嗎？",
    lang_join_mall_1: "入駐",
    lang_join_already: "已入駐",
    lang_submit_record_already: "已提交申請",
    lang_reg_date: "註冊時間",
    lang_login_date: "登錄時間",
    lang_type: "類型",
    lang_island_url: "島嶼鏈接",
    lang_account_stoped: "賬戶已被停用",
    lang_go_mall_confirm_2: "的商場嗎?",
    lang_shop_url: "店鋪鏈接",
    lang_copy_shop_url_alert: "已複製店鋪鏈接",
    lang_mall_signboard: "商場招牌",
    lang_mall_signboard_en: "商場英文招牌",
    lang_Half_body_photo: "半身像",
    lang_file_size_limit: "不超過",
    lang_share: "分享",
    lang_go_shop_confirm_3: "的店鋪瀏覽嗎?",
    lang_island_share_content: "互动式的虚拟立體空间的3D互動店鋪, 足不出戶, 讓你享受全新購物體驗！",
    lang_hall_share_content: "你可以收錄我的3DShopopee 名片, 讓我們的聯繫更緊密！",
    lang_mall_share_content: "創新展覽體驗，3D Shopopee 展位讓你身臨其境！",
    lang_agent_share_content: "歡迎申請我們的產品代理！",
    lang_scale: "大小",
    lang_ratio: "比例",
    lang_such_as: "如",
    lang_suggested: "建議",
    lang_Aspect_ratio: "長寬比",
    lang_Suggested_Resolution: "建議分辨率",
    lang_hall_2: "展館",
    lang_communicate: "溝通",
    lang_auth_manage: "權限管理",
    lang_start_date: "起始日期",
    lang_end_date: "結束日期",
    lang_admin_num_limit: "管理員數量上限",
    lang_create_hall_num_limit: "辦展數量上限",
    lang_mall_num_limit: "商場數量上限",
    lang_island_num_limit: "島嶼數量上限",
    lang_sub_company_limit: "子公司數量上限",
    lang_ride: "搭乘",
    lang_stop_car: "停車",
    lang_get_down: "下車",
    lang_forward_text: "前進",
    lang_mall_model: "商場模型",
    lang_server_center: "服務台",
    lang_speak_center: "演講台",
    lang_t_stage: "T台",
    lang_stage: "舞台圖片",
    lang_taxi: "的士",
    lang_my_hall_des: "查看和管理您的展會",
    lang_return_search: "返回搜索",
    lang_download_doc: "下載文檔",
    lang_hongkong_map: "香港地圖",
    lang_my_ads: "我的推廣",
    lang_title_en: "英文標題",
    lang_youtube_video_url: "youtube視頻鏈接",
    lang_red_url: "小紅書鏈接",
    lang_facebook_url: "facebook鏈接",
    lang_titok_url: "tiktok鏈接",
    lang_my_video: "我的視頻",
    lang_3d_shop_share: "3D店鋪分享",
    lang_open_shop_Transaction_fees_des: "提示：每次交易 10% 交易費",
    lang_use_paypal_pay: "使用Paypal代理支付",
    lang_select_chat_method: "選擇聊天方式",
    lang_store_status: "店鋪狀態",
    lang_select_status_method: "選擇店鋪網站",
    land_store_not_opent:"商家暫未開業,請下次再來",
    land_disable_auxiliary_collection:"統一收款",
    land_hall_model:"模型",
    land_hall_exhibition_model:"國際會展模型",
    land_hall_exhibition_model2:"本地會展模型",
    land_hall_exhibition_model3:"商場模型",
    lang_apply_exhibition:"申請參展",
    lang_successfully_completed :"完滿舉辦成功",
    lang_start_promoting_images :"開始推廣圖",
    lang_end_promoting_images :"結束推廣圖",
    lang_end_promoting_links:"結束推廣鏈接",
    lang_product_cost_is_not_null:"產品價格不能為空",
    lang_Please_include_the_order_number_in_the_transfer_instructions:"請將訂單號寫入轉賬說明中",
    lang_Total_order_quantity:"總下單量",
    lang_Total_amount:"總金額",
    lang_Confirm_the_total_amount:"確認總金額",
    lang_Total_views:"總瀏覽量",
    lang_The_event_has_ended:"活動已經結束, 不能購買!",
    lang_sell:"出售",
    lang_discount_coupons:"優惠券",
    lang_coupons_amount:"優惠金額",
    lang_coupons_discount:"優惠折扣",
    lang_Advanced_Setting: "進階設定",
    lang_Nofilling_Norestrictions:"0或不填寫為不限",
    lang_Quantity_used:"使用數量",
    lang_Promo_Number:"促销编号",
    lang_Full_amount:"滿",
    lang_Reduce_amount:"減"

}

export default zh